<template lang="pug">

  .lesson-test-header
    .lesson-test-header__title
      | {{title}}
    .lesson-test-header__position(
      v-if="typeof currentQuestionIdx === 'number'"
    )

</template>

<script>
export default {
  props: ['title', 'currentQuestionIdx', 'questionsLength']
};
</script>
